import React from 'react';

import { useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../utils';
import { BASE_URL } from '../../../config/environmentConfig';
import { BUTTON_TYPE, ButtonComponent } from '../../components/ButtonComponent';
import { LoginLayout } from '../../components/login/LoginLayout';

import './StripeSuccess.css';
import '../login/Login.scss';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
}

const StripeSuccess: React.FC<Props> = props => {
    const navigate = useNavigate();

    const handleReturnToStripe = (): void => {
        window.location.href = 'https://dashboard.stripe.com';
    };

    return (
        <LoginLayout>

            <div className="form-container">
                <a
                    href={BASE_URL.LOGIN_URL}
                    target="_blank"
                    className="login-logo-link d-block text-center mb-20 w-100"
                    rel="noreferrer"
                >
                    <img
                      className="cursor-pointer login-logo"
                      src={toAbsoluteUrl('/media/flex-logo-small.svg')}
                      alt="logo"
                    />
                </a>

                <div className="stripe-success-container w-100">
                    <img
                      className="stripe-success-icon d-block mx-auto mb-10"
                      src={toAbsoluteUrl('/media/icons/rocket.svg')}
                      alt="success-icon"
                    />
                    <h2 className="mb-20 text-center">All set, you can return to Stripe</h2>
                    <p className="mb-20 text-center">Your account was successfully connected, you can return to your Stripe Dashboard.</p>

                    <div className="d-flex justify-content-center">
                        <ButtonComponent
                            buttonType={BUTTON_TYPE.DEFAULT_BLACK}
                            buttonName="Return to Stripe"
                            onButtonClick={handleReturnToStripe}
                            additionalClass="w-200px align-self-center"
                        />
                    </div>
                </div>
            </div>
        </LoginLayout>
    );
};

export default StripeSuccess;
